export default __webpack_public_path__ + "img/2.asset.0d7b8cc9.jpeg";